import React from 'react';
import { useTenantContext } from '../../tenant/TenantContext';

const isOutOfStock = (product) => product.quantity > product.stock;

export const ShowReconciledCart = ({ cart }) => {
    const { pendingOrders } = useTenantContext();
    const pendingOrdersEnabled = pendingOrders?.enabled ?? false;
    const deprecated = cart?.deprecatedProducts ?? [];
    const hasDeprecated = deprecated.length > 0;
    const hasOutOfStock = deprecated.some(isOutOfStock);

    const headerBg = hasDeprecated ? 'bg-danger text-white' : 'bg-success text-white';
    const badgeBg = hasDeprecated ? 'bg-light text-danger' : 'bg-light text-success';
    const statusText = hasDeprecated
        ? 'Productos desactualizados - revise su pedido'
        : 'No hay productos desactualizados';

    return (
        <section className="container my-4">
            <div className={`p-3 rounded shadow-sm ${headerBg} d-flex justify-content-between align-items-center`}>
                <h2 className="h6 mb-0">{statusText}</h2>
                <span className={`badge ${badgeBg}`}>{deprecated.length}</span>
            </div>
            {hasOutOfStock && (
                <div className="alert alert-info mt-3 mb-0">
                    <p className="mb-0">
                        De algunos productos de tu pedido no tenemos ahora mismo todas las
                        unidades que pides. {pendingOrdersEnabled ? (
                            <>Vuelve al carrito y ajusta las unidades, o usa
                            allí <strong>Añadir a pendientes</strong> para que te guardemos
                            las que faltan.</>
                        ) : (
                            <>Vuelve al carrito y ajusta las unidades.</>
                        )}
                    </p>
                </div>
            )}
            {hasDeprecated && (
                <ul className="list-group mt-3">
                    {deprecated.map((product) => (
                        <li key={product.id} className="list-group-item">
                            <div className="d-flex flex-column gap-2">
                                <div>
                                    <span>{product.name}</span>
                                    <br />
                                    <small className="text-muted">REF: {product.code}</small>
                                </div>
                                {isOutOfStock(product) ? (
                                    <small className="text-danger">
                                        Sin stock suficiente: pedidas {product.quantity}, disponibles {Math.max(product.stock, 0)}.
                                        {pendingOrdersEnabled
                                            ? ' Ajústalo desde el carrito o mándalo allí a pendientes.'
                                            : ' Ajústalo desde el carrito.'}
                                    </small>
                                ) : (
                                    <small className="text-warning">Revise el precio o condiciones desde el carrito</small>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
};
